import React from 'react';
import { CheckIcon } from 'lucide-react';
import { tomos, tomoIncludes } from '../data/tomos';
import { Emoji } from './Emoji';
export function Tomos() {
  return <section id="megapack" className="w-full bg-forest-900 py-20" style={{
    paddingTop: "1px",
    paddingBottom: "17px"
  }} data-id="element-254" data-mp="139uy6h7xsb95">
      <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-255" data-mp="1ccmdwt7uht6l">
        <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-cream sm:text-[2.5rem]" style={{
        paddingTop: "20px"
      }} data-id="element-256" data-mp="1ca9ndro0uahx">
          Mega Pack Cocina Lista
        </h2>
        <p className="mt-4 font-display text-2xl font-extrabold tracking-tight text-lime-400 sm:text-3xl" data-id="element-257" data-mp="201yiffs89d2k">
          6 Tomos + 6 Bonos — Todo resuelto.
        </p>
        

        <ul className="mt-10 grid grid-cols-3 gap-3 sm:grid-cols-6" data-id="element-258" data-mp="1w14ysyltikfh">
          {tomos.map(tomo => <li key={tomo.number} className="flex h-24 flex-col justify-end rounded-lg p-2 shadow-card sm:h-28" style={{
          backgroundColor: tomo.accent
        }} data-id="element-259" data-mp="5ofo0ethualh">
              <span className="font-display text-[11px] font-extrabold uppercase leading-tight tracking-tight text-forest-950" data-id="element-260" data-mp="34rht0u4zy8zv">
                {tomo.tag}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl border border-lime-400/20 bg-forest-950 p-6 text-left sm:p-8" style={{
        paddingTop: "11px",
        height: "1675px",
        width: "338px"
      }} data-id="element-261" data-mp="3enusy9r4xj32">
          <p className="inline-flex items-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-lime-400" style={{
          fontSize: "18px"
        }} data-id="element-262" data-mp="3oez7578zkzwu">
            <Emoji symbol="💪" data-id="element-263" data-mp="3sidoq2ckpoce" />
            6 tomos completos
          </p>

          <ol className="mt-6 flex flex-col gap-7" data-id="element-264" data-mp="1aj0rwrejeab">
            {tomos.map(tomo => <li key={tomo.number} className="flex gap-4" data-id="element-265" data-mp="69cdvo2s139y">
                <span aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 rounded-[3px]" style={{
              backgroundColor: tomo.accent
            }} data-id="element-266" data-mp="231cm70o2mpq8" />
                <div data-id="element-267" data-mp="281ihcqtjuud2">
                  <h3 className="font-display text-[15px] font-extrabold leading-snug text-cream" data-id="element-268" data-mp="280pkqiob1l8n">
                    <Emoji symbol={tomo.emoji} className="mr-2" data-id="element-269" data-mp="2001geckam9ay" />
                    Tomo {tomo.number} —{' '}
                    <span className="uppercase" data-id="element-270" data-mp="1w095ht7ffr2f">{tomo.title}</span>
                  </h3>
                  
                  <ul className="mt-3 flex flex-col gap-2" data-id="element-271" data-mp="29vkynw5xp9h8">
                    {tomo.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5 text-[14px] leading-snug text-cream/85" data-id="element-272" data-mp="250xjwp0qftfu">
                        <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-lime-500" data-id="element-273" data-mp="2ex0jpo843fzm">
                          <CheckIcon className="h-2.5 w-2.5 text-forest-950" strokeWidth={4} aria-hidden="true" data-id="element-274" data-mp="2soyo5lqvonpg" />
                        </span>
                        {bullet}
                      </li>)}
                  </ul>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mx-auto mt-8 inline-flex max-w-xl flex-wrap items-center justify-center gap-2 font-display text-lg font-extrabold tracking-tight text-cream sm:text-xl" data-id="element-275" data-mp="2xo1r90nasjus">
          6 tomos. 6 situaciones distintas de tu vida. Un solo sistema que las
          resuelve todas.
          <Emoji symbol="🌿" data-id="element-276" data-mp="37b4aslac72oo" />
        </p>

        <div className="mt-12 rounded-3xl border border-lime-400/20 bg-forest-800 p-8 text-left" style={{
        paddingLeft: "0px",
        paddingRight: "0px",
        height: "415px"
      }} data-id="element-277" data-mp="37a2r5sf997vc">
          <h3 className="text-center font-display text-lg font-extrabold uppercase tracking-[0.12em] text-cream" data-id="element-278" data-mp="2xl2q83h702ei">
            Cada tomo incluye
          </h3>
          <ul className="mt-6 flex flex-col gap-4" style={{
          paddingLeft: "14px"
        }} data-id="element-279" data-mp="32dvpibtw6ij7">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-280" data-mp="2tj7owyz9hp0q">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lime-500" data-id="element-281" data-mp="2thd0haos7erw">
                  <CheckIcon className="h-3 w-3 text-forest-950" strokeWidth={3} aria-hidden="true" data-id="element-282" data-mp="2jla12clbdu8n" />
                </span>
                <span className="text-[15px] font-medium leading-relaxed text-cream/85" style={{
              width: "234px",
              height: "34px"
            }} data-id="element-283" data-mp="3mwqkj0qz7658">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}